import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {settheInternalescalationActions}  from "../../../../../Redux/Slice"
import Internalpiechart from './Internalpiechart';
import InternallevelOpenpie from './InternallevelOpenpie';


const Internalescalationdash = ({
       datas,
        date,
        status,
        priority,
        department
}) => {
  const dispatch = useDispatch()
  const state = useSelector((state )=>state)

  const responseData = state.internalEscalationsdashboard.Escalation_dashboard_?.closed_data
  const responseDataOpen = state.internalEscalationsdashboard.Escalation_dashboard_?.opened_data

  const pieChartData = [
    {
      id: 0,
      value: responseData?.L1_closed_count || 0,
      label: 'L1 Count',
      color: 'rgb(46, 199, 109)',
    },
    {
      id: 1,
      value: responseData?.L2_closed_count || 0,
      label: 'L2 Count',
      color: 'rgb(255, 197, 0)',
    },
    {
      id: 2,
      value: responseData?.L3_closed_count || 0,
      label: 'L3 Count',
      color: 'rgb(255, 149, 56)',
    },
 
  ];

  const pieChartData_Inprogress = [
    {
      id: 0,
      value: responseDataOpen?.L1_opened_count || 0,
      label: 'L1 Count',
      color: 'rgb(46, 199, 109)',
    },
    {
      id: 1,
      value: responseDataOpen?.L2_opened_count || 0,
      label: 'L2 Count',
      color: 'rgb(255, 197, 0)',
    },
    {
      id: 2,
      value: responseDataOpen?.L3_opened_count || 0,
      label: 'L3  Count',
      color: 'rgb(255, 149, 56)',
    },
 
  ];



  useEffect(()=>{
            if(state.ClientBranchIDs.SUBROLE == 3){

    const payload ={
        state: datas.state,
                region: datas.region,
                zone: datas.zone,
                department:department,
                date:date,
                priority:priority,
    }
    dispatch(settheInternalescalationActions(payload))
  }
    },[datas    ,department  ,priority , date, ])
  
  return (

        <div style={{ display: 'flex',flexDirection:"column" }}>
      <div style={{ display: 'flex',flexDirection:"row" , width:"100%"}}>
    <h3 style={{display:"flex", justifyContent:"flex-start", width:"50%"}}>{"Resolutions by Escalation Stage"}</h3>
    <h3 style={{display:"flex", justifyContent:"flex-start" , width:"50%"}}>{"Pending Tickets by Escalation Stage"}</h3>
</div>
      <div style={{ display: 'flex',flexDirection:"row",justifyContent:"space-between" }}>

<div className='col-6'>
          <Internalpiechart data={pieChartData} level={"Escalation Level Matrix"}/>

</div>
<div className='col-6'>

                <InternallevelOpenpie data={pieChartData_Inprogress} level={"Escalation Level Matrix"}/>
</div>

</div>
    </div>
  );
};

export default Internalescalationdash;
